module.exports = __webpack_public_path__ + "img/126.6.db7801e3.png";